import styled, { css } from 'styled-components';
import { ParagraphXSmallRegular } from 'components/Typography';
import { InputLabel, InputWrapper, InputElement } from '@econsult/econsult-ui/dist/components/Input/InputStyles';
import { Notification as SBNotification } from '@econsult/econsult-ui/dist/components/Notification';
import { formInputLabelStyles, formInputElementStyles } from 'components/FormInput/style';
import { Div } from 'components/Div';
import { Label as DatepickerLabel } from '@econsult/econsult-ui/dist/components/Datepicker';

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 0.8rem;
`;

export const Legend = styled(ParagraphXSmallRegular).attrs({ as: 'legend' })`
  padding: 0;
`;

export const LegendInfo = styled(Legend)`
  padding: 1rem;
  border: 1px solid ${({ theme }) => theme.colorSecondarySecondary60};
  background: ${({ theme }) => theme.colorSecondarySecondary30};
  color: ${({ theme }) => theme.colorPrimaryPrimary100};
  border-radius: 0.5rem;
`;

const stylesToFixFieldsetGapLayoutBug = css`
  && > * {
    margin: 0;
  }

  && > * + * {
    margin-top: 1.5rem;
  }
`;

export const FieldSet = styled.fieldset`
  border: none;
  padding: 0;
  margin: 0;
  ${stylesToFixFieldsetGapLayoutBug};
`;

export const Validation = styled(SBNotification)`
  flex: 0;
`;

export const FlexInputLabel = styled(InputWrapper)`
  flex-direction: column;
  display: flex;
  flex: 1 1 auto;
`;

export const FlexInput = styled(InputElement)`
  ${formInputElementStyles};
  place-items: flex-start;
  resize: none;
  line-height: 1;
`;

export const FlexInputSpan = styled(InputLabel)`
  ${formInputLabelStyles};
`;

export const InputRow = styled(Div)`
  gap: 1rem;
  align-items: flex-end;
  button[type=submit] {
    margin-left: auto;
  }
`;

export const FieldLabel = styled(DatepickerLabel)`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const FieldLabelWithPlacement = styled(FieldLabel)`
  ${({ row }) => (row ? `grid-row: ${row};` : '')}
  ${({ column }) => (column ? `grid-column: ${column};` : '')}
  ${({ column, columnSpan }) => (columnSpan ? `grid-column: ${column} / span ${columnSpan};` : '')}
`;
